import { createElement } from 'react';
import classnames from 'classnames';

var spacings = {"minuscule":"_340SlNuzSDQ-","smallest":"H1BK-YSBQBQ-","smaller":"xUe31mY0kro-","small":"rDJFaGPzCbE-","base":"SRYe3DkjH1c-","large":"_7TZ4MI3kr4Y-","larger":"jvPl3aAN9PA-","largest":"fFTgb4ra1X0-","extravagant":"kKnfL37LO6A-"};

var styles = {"padded":"_4On2F-4nWuY-"};

function Content({ children, spacing = "base", type = "div", }) {
    const className = classnames(styles.padded, spacings[spacing]);
    return createElement(type, { className }, children);
}

export { Content as C };
